import React from 'react';
import { Link  } from "react-router-dom";
import i18n from '../../i18n/i18n.js';
import AppHeader from '../../components/AppHeader/AppHeader';
import { Utils, NavigateTo } from '../../Utils';

import './Welcome.css';
 
class Welcome extends React.Component {

  emptyFormData = {
    email: '',
  };

  emptyFormErrors = {
    email: '',
  };

  constructor(props) {
    super(props);
    
    this.state = {
      formData: { ...this.emptyFormData },
      formErrors: { ...this.emptyFormErrors },
    };
  }

  componentDidMount() {
    const login_email = Utils.localSorageGetWithExpiry('login_email_' + i18n.resolvedLanguage);

    if (!!login_email)
    {
      this.state.formData.email = login_email;

      this.setState({formData: this.state.formData});
    }
  }

  hide() {}

  handle_submit(event) {
    event.preventDefault();

    const formData = this.state.formData;

    Utils.get_server_data(
      '',
      {
        ajax_event:'get_user_is_registered',
        APICACHE:'false'
      }, 
      {
        ajax_event: 'get_user_is_registered',
        formData: JSON.stringify(this.state.formData),
      }
    )
    .then((res)=>{

        Utils.localSorageSetWithExpiry('login_email_' + i18n.resolvedLanguage, formData.email, Number.MAX_SAFE_INTEGER);

        if (res.success)
        {
          window.location.href = '/sign_in';
        } 
        else 
        {
          window.location.href = '/account_create';
        }
        /* // a hibaüzenetet direkt nem jelenítjük meg
        
        else 
        {
          var formErrors = this.state.formErrors;
          
          formErrors.email = i18n.t('welcomeEmailError');

          this.setState({formErrors}, () => {
            setTimeout(() => {
              formErrors.email = '';
  
              this.setState({formErrors: formErrors});
            }, 5000);
          });
        }
        */
    });
  }

  handle_change(event, formDataKey, force_value = null) {
    const formData = this.state.formData;

    formData[formDataKey] = force_value !== null ? force_value : event.target.value;

    this.setState({formData});
  }

  /**
   * Render the component.
   *
   * @return {ReactElement}
   *  The rendered component.
   */
  render() {
    const {formData, formErrors } = this.state;

    return <div className={`container no-animation page_welcome`}>
        <div className="content">

        <AppHeader logo="logo_white.svg"></AppHeader>

        <div className="connect">
          <h2>{i18n.t('welcomeText1')}</h2>
          <p>{i18n.t('welcomeText2')}</p>
          <div className="welcome_form">
            {/*<Link data-type="in_app" className="button" to="/account_create">{i18n.t('welcomeRegistration')}</Link>*/}

                <div className="form_wrapper">
                 
                  <form onSubmit={(e) => this.handle_submit(e)}>
                    
                      <div className={`field ${formErrors.email !== '' ? "error" : ""}`}>
                          <input placeholder={i18n.t('welcomeEmailPlaceholder')} name="app_email" type="email" value={formData.email} onChange={(e) => this.handle_change(e, 'email')} />
                          {(formErrors.email.length) ? <div className="form_error"  dangerouslySetInnerHTML={{__html: formErrors.email}}></div> : '' }
                      </div>

                      <input className="welcome_next" type="submit" value={i18n.t('welcomeNext')} />

                  </form> 
                  
                </div>

          </div>
        </div>

      </div>
    </div>;
  }
};

export default Welcome;